import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PafListsService } from '../../all-services';
import { SharedDataService } from '../../all-services';
import { Department } from '../../all-models';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';


  type DepartmentWithDisplay = Department & {
    comboDisplay: string;
  };


@Component({
  selector: 'departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentsComponent implements OnInit, OnChanges {

  lstRegions:DepartmentWithDisplay[]=[];
  lstDepartments:DepartmentWithDisplay[]=[];
  
  @Input() showRegions?:boolean=true;
  @Input() showDepartments?:boolean=true;
  @Input() includeJoker?: boolean = true;
  @Input() required: boolean = false;

  @Input() multiple?: boolean = false;

  // Gestion du modèle simple
  @Input() region?: Department;
  @Input() department?: Department;
  @Output() regionChange : EventEmitter<Department | undefined> = new EventEmitter<Department | undefined>();
  @Output() departmentChange : EventEmitter<Department | undefined> = new EventEmitter<Department | undefined>();

  //Gestion du modèle multiple
  @Input() regionIds?: number[];
  @Input() departmentIds?: number[];
  @Output() regionIdsChange : EventEmitter<number[] | undefined> = new EventEmitter<number[] | undefined>();
  @Output() departmentIdsChange : EventEmitter<number[] | undefined> = new EventEmitter<number[] | undefined>();
  

  @Output() listDptsLoaded : EventEmitter<Department[]> = new EventEmitter<Department[]>();
  @Output() listRegionsLoaded : EventEmitter<Department[]> = new EventEmitter<Department[]>();
  

  constructor(public sharedDataSvc: SharedDataService, public pafLists: PafListsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['includeJoker']) {
      this.updateLstSelonJoker();
    }
    if (changes['region']) {
      this.onRegionChange(this.region);
    }
    if (changes['department']) {
      this.onDepartmentChange(this.department);
    }
    if (changes['regionIds']) {
      setTimeout(() => {
        this.handleFilterDpt('');
        if (this.multiselectDptsModel) {
          this.multiselectDptsModel = this.lstDptsFiltered.filter(dpt=>this.multiselectDptsModel.some(id=>dpt.Id==id)).map(dpt=>dpt.Id);
        }
        this.regionIdsChange.emit(this.regionIds);
      }, 0);
    }
    if (changes['departmentIds']) {
      if (this.departmentIds && this.multiselectDptsModel != this.departmentIds) {
        setTimeout(() => {
          this.multiselectDptsModel = this.departmentIds;
        }, 0);
      }
    }
  }

  private _regionId?:number;
  get regionId():number{
    return this._regionId;
  }
  set regionId(value:number){
    if (this.regionId!= value){
      this._regionId = value ?? undefined;
      this.onRegionChange(this.sharedDataSvc.regions.find(r=>r.Id==value) ?? null);
    }
  }
  private _dptId?: number;
  get dptId():number | undefined{
    return this._dptId;
  }
  set dptId(value:number | undefined){
    if (this.dptId!= value){
      this._dptId = value ?? undefined;
      this.onDepartmentChange(this.sharedDataSvc.departments.find(dpt=>dpt.Id==value) ?? undefined);
    }
  }

  public parsedDpts:Department[]=[];
  updateLstDpts(region:Department){
    if (!region || region.Id==0){
      this.parsedDpts = this.lstDepartments;
    } else {
      this.parsedDpts =  this.lstDepartments.filter(d=>d.Id==0 || d.RegionName==region.RegionName);
    }
  }

private allRegions:DepartmentWithDisplay=null;
private allDpts: DepartmentWithDisplay =null;
  ngOnInit(): void {
    if (this.sharedDataSvc.allListsLoaded) {
    this.loadValues();
    } else {
      let sub = this.sharedDataSvc.allListsLoadedChange.subscribe({next:res=>{
        this.loadValues();
        sub.unsubscribe;
      }});
    }
  }

  loadValues(): void {
    this.allRegions = { Id: 0, DptNumber: "", DptName: "", RegionName: "Toutes", comboDisplay: "Toutes" };
    this.allDpts = { Id: 0, DptNumber: "", DptName: "", RegionName: "Tous", comboDisplay: "Tous" };
    this.lstRegions = this.sharedDataSvc.regions.map(r => ({
      ...r,
      comboDisplay: r.RegionName
    }));
    this.lstDepartments = this.sharedDataSvc.departments.map(d => ({
      ...d,
      comboDisplay: `${d.DptNumber} - ${d.DptName}`
    }));
    this.updateLstSelonJoker();
    this.listRegionsLoaded.emit(this.lstRegions);
    this.listDptsLoaded.emit(this.lstDepartments);
    this.handleFilterDpt('');
  }

  updateLstSelonJoker():void{
    this.lstRegions = this.lstRegions.filter(d=>d.Id!=0);
    this.lstRegions.sortObject('RegionName');
    this.lstDepartments=this.lstDepartments.filter(d=>d.Id!=0);
    this.lstDepartments.sortObject('DptNumber');
      if (this.includeJoker){
      this.lstRegions.splice(0,0,this.allRegions);
      this.lstDepartments.splice(0,0,this.allDpts);
    }
  }
  
  onRegionChange(item:Department):void{
    this.region=item;
    let found:number = 
      this.department && this.department?.RegionName==item?.RegionName ? 
      this.department.Id :
      this.parsedDpts.length>0 ? 
      this.parsedDpts[0].Id :
      undefined;
      if (found != this.dptId){
        this.dptId = found;
      }    
    this.regionChange.emit(this.region);
  }

  onDepartmentChange(item:Department):void{    
    this.department=item;
    if (item?.Id){
      let region2Sel:Department=this.lstRegions.find(r=>r.RegionName==item.RegionName);
      if (region2Sel?.Id!= this.region?.Id){
        this.onRegionChange(region2Sel);
      }
    }
    this.departmentChange.emit(this.department);
  }


  get multiselectRegionsModel():number[] {
    return this.regionIds || [];
  }
  set multiselectRegionsModel(values: number[]|null){
    if (values == null) values = [];
    if (values.some(v=>v==0) && !this.regionIds.some(v=>v==0)) {
      values=[0];
    } else if (values.length>1) {
      values = values.filter(v=>v!=0);
    } 
    this.regionIds=values;
    this.handleFilterDpt('');
    if (this.multiselectDptsModel) {
      this.multiselectDptsModel = this.lstDptsFiltered.filter(dpt=>this.multiselectDptsModel.some(id=>dpt.Id==id)).map(dpt=>dpt.Id);
    }
    this.regionIdsChange.emit(this.regionIds);
  }

  get multiselectDptsModel():number[] | null{
    return this.departmentIds || null;
  }
  set multiselectDptsModel(values: number[]|null){
    if (!!values){
      if ((values||[]).some(v=>v==0) && !this.departmentIds.some(v=>v==0)) {
        values=[0];
      } else if (values.length>1) {
        values = values.filter(v=>v!=0);
      } 
    }
    this.departmentIds=values;

    this.departmentIdsChange.emit(this.departmentIds);
  }



  get lstRegionsSel():Department[]{
    return this.lstRegions.filter(r=>(this.regionIds||[]).some(id=>id==r.Id || id==0));
  }

  public lstDptsFiltered:Department[]=this.lstDepartments;
  searchDptValue : string='';

  handleFilterDpt(value: string) : void {
    this.searchDptValue = value;
    if (!this.regionIds || this.regionIds.length==0 || this.regionIds.some(r=>r==0)) {
      this.lstDptsFiltered = this.lstDepartments.filter(dpt=>!this.searchDptValue || dpt.comboDisplay.toLowerCase().indexOf(this.searchDptValue.toLowerCase())>=0);
    } else {
      let dpts:DepartmentWithDisplay[] = this.lstDepartments
        .filter(dpt=>this.lstRegionsSel.some(region=>region.RegionName==dpt.RegionName))
        .filter(dpt=>!this.searchDptValue || dpt.comboDisplay.toLowerCase().indexOf(this.searchDptValue.toLowerCase())>=0);
        this.lstDptsFiltered =dpts;
    }
  }

  public filterSettings: DropDownFilterSettings = {
    operator: 'contains',
    caseSensitive: false
  };
}

